export default {
  menus: []
}
